import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import Icon from '../containers/icon';
import SegmentedPicker from '../controls/segmentedPicker';

/**
 *  Compact search settings for cabinet text search. Renders as a single icon
 *  alongside the search label; the pickers live in a popover so the defaults
 *  (all words, contains) stay out of the way for users who never open it.
 */
const SearchOptions = ({
  operator: _operator = 'and',
  matchMode: _matchMode = 'contains',
  onChange
}) => {
  const [id] = useState(`search-options-${uuid()}`);
  return /*#__PURE__*/React.createElement("span", {
    id: id,
    role: "button",
    tabIndex: 0,
    title: "Search options",
    "data-testid": "t-so-toggle",
    className: "t-so-toggle",
    style: {
      cursor: 'pointer',
      outline: 0,
      paddingLeft: 5
    },
    onKeyDown: () => {}
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "gear",
    ariaLabel: "Search options"
  }), /*#__PURE__*/React.createElement(UncontrolledPopover, {
    trigger: "legacy",
    placement: "bottom",
    target: id,
    container: "body"
  }, /*#__PURE__*/React.createElement(PopoverHeader, null, "Search Options"), /*#__PURE__*/React.createElement(PopoverBody, {
    style: {
      padding: 10,
      width: 220
    }
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    className: "t-so-operator",
    label: "Multiple words",
    names: ['Any', 'All'],
    values: ['or', 'and'],
    value: _operator,
    allowNull: false,
    onChange: value => onChange('textOperator', value)
  }), /*#__PURE__*/React.createElement(SegmentedPicker, {
    className: "t-so-match-mode",
    label: "Match",
    names: ['Contains', 'Exact'],
    values: ['contains', 'exact'],
    value: _matchMode,
    allowNull: false,
    onChange: value => onChange('textMatchMode', value)
  }))));
};
SearchOptions.propTypes = {
  operator: PropTypes.oneOf(['or', 'and']),
  matchMode: PropTypes.oneOf(['contains', 'exact']),
  onChange: PropTypes.func.isRequired
};
export default SearchOptions;